(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__productCardCartSyncInit) return;
  window.__productCardCartSyncInit = true;

  document.addEventListener('DOMContentLoaded', () => {
    const cards = document.querySelectorAll('.product-card');

    for (const card of cards) {
      const productId = card.dataset.productId;
      const addBtn = card.querySelector('.add-to-cart-btn');
      const btnText = card.querySelector('.btn-text');
      const btnLoader = card.querySelector('.btn-loader');
      const counter = card.querySelector('.quantity-counter');
      const qtyValue = card.querySelector('.qty-value');
      const plus = card.querySelector('.qty-plus');
      const minus = card.querySelector('.qty-minus');

      if (!productId || !addBtn || !btnText || !btnLoader || !counter || !qtyValue || !plus || !minus) {
        continue;
      }

      let isUpdating = false;
      let currentItemKey = null;

      const updateVisibility = (quantity) => {
        const qty = Number(quantity) || 0;
        if (qty > 0) {
          qtyValue.textContent = String(qty);
          addBtn.classList.add('hidden');
          counter.classList.remove('hidden');
          return;
        }
        addBtn.classList.remove('hidden');
        counter.classList.add('hidden');
      };

      const showLoading = () => {
        btnText.classList.add('hidden');
        btnLoader.classList.remove('hidden');
        addBtn.disabled = true;
      };

      const hideLoading = () => {
        btnText.classList.remove('hidden');
        btnLoader.classList.add('hidden');
        addBtn.disabled = false;
      };

      const syncQuantityFromCart = async () => {
        try {
          const res = await fetch('/cart.js', { credentials: 'same-origin' });
          if (!res.ok) {
            return Number(qtyValue.textContent) || 0;
          }
          const cart = await res.json();
          const item = cart.items.find((i) => String(i.id) === String(productId));
          currentItemKey = item ? item.key : null;
          const qty = item ? item.quantity : 0;
          updateVisibility(qty);
          return qty;
        } catch (e) {
          return Number(qtyValue.textContent) || 0;
        }
      };

      const changeQuantity = async (nextQty) => {
        try {
          if (!currentItemKey) {
            await syncQuantityFromCart();
          }

          if (!currentItemKey) {
            return false;
          }

          const safeQty = Math.max(Number(nextQty) || 0, 0);
          const payload = { updates: {} };
          payload.updates[currentItemKey] = safeQty;

          const response = await fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(payload)
          });

          if (!response.ok) {
            throw new Error('Cart change failed');
          }

          const cart = await response.json();
          const item = cart.items.find((i) => i.key === currentItemKey || String(i.id) === String(productId));
          currentItemKey = item ? item.key : null;
          updateVisibility(item ? item.quantity : 0);
          return true;
        } catch (e) {
          await syncQuantityFromCart();
          return false;
        }
      };

      const withLock = async (task) => {
        if (isUpdating) return;
        isUpdating = true;
        addBtn.disabled = true;
        plus.disabled = true;
        minus.disabled = true;

        try {
          await task();
        } finally {
          isUpdating = false;
          addBtn.disabled = false;
          plus.disabled = false;
          minus.disabled = false;
        }
      };

      syncQuantityFromCart();

      addBtn.addEventListener('click', async (e) => {
        e.preventDefault();

        await withLock(async () => {
          showLoading();

          try {
            const addResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: productId, quantity: 1 })
            });

            if (!addResponse.ok) {
              throw new Error('Add to cart failed');
            }

            await syncQuantityFromCart();
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:item-added'));

            const drawer = document.getElementById('cartDrawer');
            const overlay = document.getElementById('cartOverlay');
            if (typeof window.openCartDrawer === 'function') {
              window.openCartDrawer();
            } else if (drawer && overlay) {
              drawer.classList.remove('translate-x-full');
              overlay.classList.remove('hidden');
            } else if (typeof toggleCartDrawer === 'function') {
              toggleCartDrawer();
            }
          } catch (e) {
            console.error('Error adding item to cart:', e);
          } finally {
            hideLoading();
          }
        });
      });

      plus.addEventListener('click', async () => {
        await withLock(async () => {
          const nextQty = (Number(qtyValue.textContent) || 0) + 1;
          const changed = await changeQuantity(nextQty);
          if (changed) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:item-changed'));
          }
        });
      });

      minus.addEventListener('click', async () => {
        await withLock(async () => {
          const nextQty = Math.max((Number(qtyValue.textContent) || 0) - 1, 0);
          const changed = await changeQuantity(nextQty);
          if (changed) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:item-changed'));
          }
        });
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
